import type { SorteDeLien } from '@nextilt/commun';

/**
 * **Le dessin d'un lien sur la carte** (chantier liens-entre-bulles, ticket 03, spec du chantier,
 * « La carte ») : du calcul, pas de JSX. Le serveur dit la sorte, la visibilité et si un
 * « attend » retient encore ; l'écran n'en tire que le dessin, sans rien trier d'autre.
 *
 * - « attend » : pointillé, avec sa flèche (comme avant les sortes, la flèche en plus) ;
 * - « sert à » : un trait plein et fin, avec sa flèche ;
 * - « touche à » : un trait fin, sans flèche (il n'a pas de sens) ;
 * - un « attend » rempli (la bulle attendue est faite) et un lien caché montré par la touche A :
 *   en pâle.
 */
export interface DessinDUnLien {
  pointille: boolean;
  fleche: boolean;
  pale: boolean;
}

export function dessinDuLien({ sorte, visible, retient }: { sorte: SorteDeLien; visible: boolean; retient: boolean }): DessinDUnLien {
  return {
    pointille: sorte === 'attend',
    fleche: sorte !== 'touche_a',
    pale: !visible || (sorte === 'attend' && !retient),
  };
}

/** Les liens à dessiner : un lien caché ne l'est qu'avec la touche A. */
export function liensMontres<T extends { visible: boolean }>(liens: readonly T[], cachesMontres: boolean): T[] {
  return cachesMontres ? [...liens] : liens.filter((l) => l.visible);
}
